import { graphql } from 'gatsby';

export const projectFragment = graphql`
  fragment project on PRISMIC_Project {
    __typename
    _meta {
      ...meta
    }
    title
    image
  }
`;
